module.exports = __webpack_public_path__ + "img/多云.5a5b158b.png";